import { render, staticRenderFns } from "./z-transfer.vue?vue&type=template&id=0ee8f59e&"
import script from "./z-transfer.vue?vue&type=script&lang=js&"
export * from "./z-transfer.vue?vue&type=script&lang=js&"
import style0 from "./z-transfer.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports